import { checkCookie, getCookie } from '../core/cookie-manager';
import ph from '../../analytics/posthog/posthog-client';

export default class managerServices {

    checkPreferences(): void {
        
        if (!checkCookie()) return;

        const cookie = getCookie();
        if (!cookie?.details) return;

        const { preference, stats, marketing } = cookie.details;

        this.setPreference(preference);
        this.setStats(stats);
        this.setMarketing(marketing);

        ph.applyConsentPSM({
            preferences: preference,
            statistics: stats,
            marketing: marketing,
            allowFeatureFlags: true,
            sessionRecording: true,
        });

    }

    /**
     * Set preference consent for services
     * Activate services that depend on preference consent here.
     * Example:
     *   if (active) { modGoogleAnalytics.setConsent('functionality_storage'); }
     *   else { modGoogleAnalytics.revokeConsent('functionality_storage'); }
     */
    protected setPreference(active: boolean = false): void {

    }

    /**
     * Set statistics consent for services
     * Activate services that depend on statistics consent here.
     * Example:
     *   if (active) { modGoogleAnalytics.setConsent('analytics_storage'); }
     *   else { modGoogleAnalytics.revokeConsent('analytics_storage'); }
     */
    protected setStats(active: boolean = false): void {

    }

    /**
     * Set marketing consent for services
     * Activate services that depend on marketing consent here.
     */
    protected setMarketing(active: boolean = false): void {

        if (typeof (window as any).fbq !== 'function') return;
        (window as any).fbq('consent', active ? 'grant' : 'revoke');

    }

}
